import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import i18n from '../../../../../../../i18n'
import { QuestionnairesReceptionStatus } from '../../../../../../api/end-of-journey-reviews/centre/types'
import { extractAllErrorMessages } from '../../../../../../lib/utils/functions/misc.functions'

/** 2 decimals in the current language's format, as on the design (e.g. "4,25" in French, "4.25" in English). */
export const formatReviewNumber = (value: number) =>
  value.toLocaleString(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** Colour of the x/y chip from the backend's reception status (centre tab and summary). */
export const receptionStatusVariant: Record<QuestionnairesReceptionStatus, VariantColor> = {
  COMPLETE: 'success',
  NONE: 'danger',
  PARTIAL: 'warning'
}

type Props = {
  // null shows "n/a": not answered, or not in the youth's template
  text: string | null
  variant?: VariantColor
  // background over the variant's, when the row already has the variant's background
  color?: TailwindColor
}

/** A rating pill of the end-of-stay ratings tables. */
const ReviewRatingPill = ({ text, variant = 'grey', color }: Props) => (
  <Badge variant={variant} color={color} text={text ?? 'n/a'} className="whitespace-nowrap" />
)

/** The backend's reason when the ratings cannot be read (e.g. ratings on two scales), never empty data. */
export const ReviewLoadError = ({ error }: { error: Error }) => (
  <Typography variant="tag" color={tailwindColors.red.DEFAULT}>
    {extractAllErrorMessages(error).join(' ')}
  </Typography>
)

export default ReviewRatingPill
